export default __webpack_public_path__ + "static/media/co__dash__op_light.109a6ea5.png";